module.exports = __webpack_public_path__ + "fonts/iconfont.307974d0.woff2";